import { IMAGES_PATH } from "../../constants";

export function TypeformSubmitSuccess({ onSuccessMessageClose }) {
  setTimeout(() => {
    onSuccessMessageClose();
  }, 500);

  return (
    <section className="custom-form-section">
      <div className="msg-wrapper">
        <div className="msg-block">
          <img src={`${IMAGES_PATH}/thank-you.jpg`} />
          <h2>
            Thank you for taking the time! We appreciate you meeting with the
            vendor and providing your valuable feedback.
          </h2>
        </div>
      </div>
    </section>
  );
}

export function TypeformSubmitError({ message = "" }) {
  return (
    <section className="custom-form-section">
      <div className="msg-wrapper">
        <div className="msg-block already-submit-msg">
          <img src={`${IMAGES_PATH}/feedback.png`} />
          <h2 style={{color: "red"}}>Oops! Something went wrong. Please try again later.</h2>
        </div>
      </div>
    </section>
  );
}

export function TypeformFeedbackAlreadySubmitted() {
  return (
    <section className="custom-form-section">
      <div className="msg-wrapper">
        <div className="msg-block already-submit-msg">
          <img src={`${IMAGES_PATH}/feedback.png`} />
          <h2>
            Your feedback has already been submitted. Thank you for your input!
          </h2>
        </div>
      </div>
    </section>
  );
}
